import React, { useEffect, useState } from 'react';
import PageHeading from '../../components/PageHeading/PageHeading';
import Button from '../../components/Button/Button';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateFlashBar,
  updateIsLoading,
  update_breadcrumb,
} from '../../redux/action';
import { errorMessage } from '../../config/errorsMsg';
import instance from '../../service/axiosInstane';
import WebLinkTable from '../../components/WebLinkTable/WebLinkTable';
import { SortOrderType, WeblinkSource } from '../../config/enum';
import { colors } from '../../config/constants';
import { errorMessageAutoCapitalize, totalPages } from '../../config/helpers';
import { ClickAwayListener } from '@mui/material';
import { flashBarTheme } from '../../config/flashBar';
import qs from 'qs';
import Input from '../../components/Input/Input';
import { StateProps } from '../../redux/reducer';
import List from '../../components/List/List';
import { successMessage } from '../../config/keyword';

type RequestProps = {
  Page: number;
  PageSize: number;
  SearchText: string;
  SortBy: string;
  SortOrder: string | number;
  OrganizationFilter?: string[];
  LabelFilter?: string[];
  IsActiveFilter?: boolean;
};

type WebsiteResultProps = {
  siteOrganizationId: string;
  siteId: string;
  organizationId: string;
  siteSequenceNumber: number;
  name: string;
  host: string;
  siteUrl: string;
};
type SearchResultProps = {
  keywordId: string;
  siteOrganizationId: string;
  siteCrawlId: string;
  weblinkUrl: string;
  matchContent: string;
  weblinkId: string;
  weblinkPreference: number;
  isDmcaGenerated: boolean;
};

type MarkAddProps = {
  weblinkUrl: string;
  keywordId: string;
  weblinkPreference: number;
  siteOrganizationId: string;
  weblinkSource: number;
};
export type ResultProps = {
  name: string;
  organizationId: string;
  id: string;
  categoryLabelId: string;
  categoryLabelName: string;
};
type CategoryResponceProps = {
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  results?: ResultProps[];
};
const ManualSearch = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state: StateProps) => state.tokenInfo.userInfo);
  const [state, setState] = useState({
    siteOrgId: '',
    websiteURL: '',
    searchKeyword: '',
  });
  const [requestWebsites, setRequestWebsites] = useState<RequestProps>({
    Page: 1,
    PageSize: 20,
    SearchText: '',
    SortBy: 'siteUrl',
    SortOrder: 0,
  });
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [weblinks, setWebLinks] = useState<RequestProps>({
    Page: page,
    PageSize: limit,
    SearchText: '',
    SortBy: '',
    SortOrder: SortOrderType.ASC,
  });
  const [weblinkResponse, setWeblinkResponse] = useState<SearchResultProps[] | null>(
    null
  );
  const [website, setWebsite] = useState<WebsiteResultProps[]>([]);
  const [websiteCount, setWebsiteCount] = useState<number>(0);
  const [showWebsite, setShowWebsite] = useState<boolean>(false);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [formErrors, setFormErrors] = useState<any>({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [websiteLoading, setWebsiteLoading] = useState(false);
  const [addKeyword, setAddKeyword] = useState<boolean>(false);
  const [category, setCategory] = useState<ResultProps[]>([]);
  const [catTotalCount, setCatTotalCount] = useState(0);
  const [categoryRequest, setCategoryRequest] = useState<RequestProps>({
    Page: 1,
    PageSize: 20,
    SearchText: '',
    OrganizationFilter: [userInfo.organizationId],
    LabelFilter: [],
    IsActiveFilter: true,
    SortBy: '',
    SortOrder: SortOrderType.ASC,
  });
  const [categoryID, setCategoryID] = useState('');
  const [categoryError, setCategoryError] = useState('');
  const [websiteList, setWebsiteList] = useState<any>({
    web: [],
  });
  const [weblinkInfo, setWeblinkInfo] = useState({
    weblinkUrl: '',
    keywordId: '',
    weblinkPreference: 0,
    siteOrganizationId: '',
    weblinkSource: 0,
  });
  useEffect(() => {
    const breadcrumb = [{ path: '/manualSearch', name: 'Manual Search' }];
    dispatch(update_breadcrumb(breadcrumb));
    getWebsites(requestWebsites);
    getAllCatogories(categoryRequest);
  }, []);

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      onManualSearch();
    }
  }, [formErrors]);

  useEffect(() => {
    const handler = setTimeout(() => {
      getWebsites(requestWebsites);
    }, 1000);
    return () => {
      clearTimeout(handler);
    };
  }, [requestWebsites.SearchText]);

  useEffect(() => {
    const handler = setTimeout(() => {
      getAllCatogories(categoryRequest);
    }, 1000);
    return () => {
      clearTimeout(handler);
    };
  }, [categoryRequest.SearchText]);

  const validation = () => {
    const error: any = {};
    if (!state.siteOrgId) {
      error.siteOrgId = 'Webiste required!';
    }
    if (!state.searchKeyword) {
      error.searchKeyword = 'Search Keyword required!';
    }
    return error;
  };

  const onSubmit = () => {
    setFormErrors(validation());
    setIsSubmit(true);
  };

  const onSearchHanlder = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setState({ ...state, searchKeyword: event.target.value });
    if (event.target.value !== '') {
      setFormErrors({ ...formErrors, searchKeyword: undefined });
    } else {
      setFormErrors({
        ...formErrors,
        [event.target.name]: `${errorMessageAutoCapitalize(
          event.target.name
        )} is required`,
      });
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setRequestWebsites({ ...requestWebsites, SearchText: e.target.value });
  };

  const getWebsites = async (obj: RequestProps) => {
    setWebsiteLoading(true);
    await instance
      .get('/site-organization-indexes/sites', {
        params: obj,
      })
      .then((response) => {
        if (response.status === 200) {
          if (response?.data?.results !== null) {
            setWebsiteList((prevState: any) => ({
              ...prevState,
              web: response?.data?.results,
            }));
            setWebsite(response?.data?.results);
            setWebsiteLoading(false);
            setWebsiteCount(response?.data?.totalCount);
          } else {
            setWebsiteList({ ...websiteList, web: [] });
            setWebsiteLoading(false);
          }
        }
      })
      .catch(() => {
        setWebsiteLoading(false);
      });
  };

  const onClickWebsite = (row: WebsiteResultProps) => {
    setShowWebsite(false);
    setRequestWebsites({ ...requestWebsites, SearchText: '' });
    setState({
      ...state,
      siteOrgId: row.siteOrganizationId,
      websiteURL: row.siteUrl,
    });
    setRequestWebsites({ ...requestWebsites, SearchText: '' });

    if (state.websiteURL !== '' || row.siteUrl !== '') {
      setFormErrors({ ...formErrors, siteOrgId: undefined });
    } else {
      setFormErrors({
        ...formErrors,
        siteOrgId: `Website required!`,
      });
    }
  };

  const onManualSearch = () => {
    getWebLinks({
      ...weblinks,
      SearchText: state.searchKeyword,
      Page: 1,
      PageSize: weblinks.PageSize,
    });
    setWebLinks({
      ...weblinks,
      SearchText: state.searchKeyword,
      PageSize: weblinks.PageSize,
      Page: 1,
    });
    setPage(1);
  };

  const markYourPreference = (item: SearchResultProps, status: number) => {
    if (item.keywordId !== null) {
      const obj = {
        weblinkUrl: item.weblinkUrl,
        keywordId: item.keywordId,
        weblinkPreference: status,
        siteOrganizationId: item.siteOrganizationId,
        weblinkSource: WeblinkSource.Index,
      };
      const updateObj = {
        weblinkPreference: status,
      };
      if (!item.isDmcaGenerated) {
        if (item.weblinkId === null) {
          addPreference(obj);
        } else {
          updatePreference(updateObj, item);
        }
      }
    } else {
      setWeblinkInfo({
        ...weblinkInfo,
        weblinkUrl: item.weblinkUrl,
        weblinkPreference: status,
        siteOrganizationId: item.siteOrganizationId,
        weblinkSource: WeblinkSource.Index,
      });
      setAddKeyword(true);
    }
  };
  const addPreference = (obj: MarkAddProps) => {
    dispatch(updateIsLoading(true));
    instance
      .post(`/weblinks`, obj)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.MARKED_PREFERENCE,
            type: flashBarTheme.SUCCESS,
          };
          getWebLinks({
            ...weblinks,
            Page: page,
            PageSize: limit,
            SearchText: state.searchKeyword,
          });
          dispatch(updateFlashBar(obj));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };
  const updatePreference = (
    obj: {
      weblinkPreference: number;
    },
    row: SearchResultProps
  ) => {
    dispatch(updateIsLoading(true));
    instance
      .put(`/weblinks/${row.weblinkId}/marke-preference`, obj)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.MARKED_PREFERENCE,
            type: flashBarTheme.SUCCESS,
          };
          getWebLinks({
            ...weblinks,
            Page: page,
            PageSize: limit,
            SearchText: state.searchKeyword,
          });
          dispatch(updateFlashBar(obj));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };
  const getWebLinks = async (obj: RequestProps) => {
    const queryString = qs.stringify(obj, { arrayFormat: 'repeat' });
    const url = `/site-review/site-organization/${state.siteOrgId}/search?${queryString}`;
    dispatch(updateIsLoading(true));
    await instance
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          if (response.data?.results !== null) {
            setWeblinkResponse(response?.data?.results);
          } else {
            setWeblinkResponse([]);
          }
          setTotalRowCount(response.data?.totalCount);
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };
  const paginateHandler = {
    onClickPageNumber: (page: number) => {
      getWebLinks({
        ...weblinks,
        Page: page,
        PageSize: limit,
        SearchText: state.searchKeyword,
      });
      setPage(page);
    },
    onNextClick: () => {
      if (page < totalPages(totalRowCount, limit)) {
        getWebLinks({
          ...weblinks,
          Page: page + 1,
          PageSize: limit,
          SearchText: state.searchKeyword,
        });
        setPage(page + 1);
      }
    },
    onPrevClick: () => {
      if (page > 1) {
        getWebLinks({
          ...weblinks,
          Page: page - 1,
          PageSize: limit,
          SearchText: state.searchKeyword,
        });
        setPage(page - 1);
      }
    },
    onFirstClick: () => {
      if (page !== 1) {
        getWebLinks({
          ...weblinks,
          Page: 1,
          PageSize: limit,
          SearchText: state.searchKeyword,
        });
        setPage(1);
      }
    },
    onLastClick: () => {
      if (page !== totalPages(totalRowCount, limit)) {
        getWebLinks({
          ...weblinks,
          Page: totalPages(totalRowCount, limit),
          PageSize: limit,
          SearchText: state.searchKeyword,
        });
        setPage(totalPages(totalRowCount, limit));
      }
    },

    limitHandler: (item: number) => {
      getWebLinks({
        ...weblinks,
        Page: 1,
        PageSize: item,
        SearchText: state.searchKeyword,
      });
      setLimit(item);
      setPage(1);
    },
  };

  const handleEnterKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      if (state.siteOrgId !== '' && state.searchKeyword !== '') {
        getWebLinks({
          ...weblinks,
          SearchText: state.searchKeyword,
          Page: 1,
          PageSize: limit,
        });
      }
      setPage(1);
    }
  };
  const loadMore = () => {
    getWebsites({
      ...requestWebsites,
      PageSize: requestWebsites.PageSize + 20,
      Page: 1,
    });
    setRequestWebsites({
      ...requestWebsites,
      PageSize: requestWebsites.PageSize + 20,
      Page: 1,
    });
  };
  const getAllCatogories = (obj: RequestProps) => {
    const queryString = qs.stringify(obj, { arrayFormat: 'repeat' });
    instance
      .get(`/categories?${queryString}`)
      .then((response) => {
        if (response.status === 200) {
          gotResponse(response.data);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };
  const gotResponse = (data: CategoryResponceProps) => {
    setCategory(data?.results as ResultProps[]);
    setCatTotalCount(data.totalCount);
  };
  const onAddKeywords = async () => {
    if (categoryID !== '') {
      const obj = {
        text: state.searchKeyword,
        categoryId: categoryID,
      };
      dispatch(updateIsLoading(true));
      await instance
        .post('/keywords', obj)
        .then((response) => {
          if (response.status === 201) {
            setAddKeyword(false);
            addPreference({ ...weblinkInfo, keywordId: response.data.id });
          }
        })
        .catch((err) => {
          setIsSubmit(false);
          const obj = {
            isOpen: true,
            message: err.response.data.Message
              ? err.response.data.Message
              : errorMessage.oops,
            type: flashBarTheme.ERROR,
          };
          dispatch(updateFlashBar(obj));
          dispatch(updateIsLoading(false));
        });
      setCategoryError('');
    } else {
      setCategoryError('Please select category');
    }
  };
  const onClickCategory = (row: ResultProps) => {
    setCategoryID(row.id);
    setCategoryError('');
  };
  const categorySearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCategoryRequest({ ...categoryRequest, SearchText: e.target.value });
  };
  const loadMoreCategory = () => {
    getAllCatogories({
      ...categoryRequest,
      PageSize: categoryRequest.PageSize + 20,
      Page: 1,
    });
    setCategoryRequest({
      ...categoryRequest,
      PageSize: categoryRequest.PageSize + 20,
    });
  };

  return (
    <>
      <div className={`mx-2`}>
        <PageHeading label="Manual Search" />
        <div className="bg-white p-2 rounded-sm shadow-md w-full">
          <div className="lg:flex lg:space-x-10">
            <div className="relative flex">
              <div className="w-full">
                <div className={`text-sm mb-1 ${colors.primaryText} pl-2`}>
                  Website
                </div>
                <div
                  onClick={() => setShowWebsite(true)}
                  className="h-8 sm:w-[300px] w-full bg-slate-50 border flex items-center relative outline-none pr-[60px] pl-2 text-sm rounded-sm focus:border-[#64CCC5] cursor-pointer"
                >
                  {state.websiteURL === '' ? (
                    <div className="text-gray-400">{'Please select website'}</div>
                  ) : (
                    state.websiteURL
                  )}
                </div>{' '}
                <div className="text-[red] text-sm pl-2 mt-1">
                  {formErrors.siteOrgId}
                </div>
              </div>

              {showWebsite && (
                <ClickAwayListener
                  onClickAway={() => {
                    setShowWebsite(false);
                    getWebsites({
                      ...requestWebsites,
                      SearchText: '',
                      PageSize: 20,
                      Page: 1,
                    });
                    setRequestWebsites({
                      ...requestWebsites,
                      SearchText: '',
                      PageSize: 20,
                      Page: 1,
                    });
                  }}
                >
                  <div className="bg-white absolute top-16 text-sm shadow-lg sm:w-[300px] max-h-[300px] w-full overflow-scroll z-[10] p-2 rounded-md">
                    <div className="relative">
                      <input
                        onClick={() => setShowWebsite(true)}
                        className="h-6 w-full border relative outline-none pr-[60px] pl-4 text-sm rounded-sm focus:border-[#64CCC5]"
                        placeholder={'Search here'}
                        onChange={(
                          e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
                        ) => handleChange(e)}
                        onKeyDown={handleEnterKeyPress}
                        autoComplete="off"
                        value={requestWebsites.SearchText}
                      />
                      <div
                        className="absolute top-[2px] right-3 cursor-pointer text-gray-600"
                        onClick={() => {
                          setRequestWebsites({ ...requestWebsites, SearchText: '' });
                        }}
                      >
                        <i className="fa-solid fa-xmark"></i>
                      </div>
                    </div>

                    <div>
                      {websiteList.web.length > 0 ? (
                        <div>
                          {website?.map(
                            (item: WebsiteResultProps, index: number) => {
                              return (
                                <div
                                  key={index}
                                  className={`mt-2 cursor-pointer p-1 hover:bg-slate-200 ${
                                    website.length !== index + 1 && 'border-b'
                                  }`}
                                  onClick={() => onClickWebsite(item)}
                                >
                                  <div className={`text-sm ${colors.primaryText}`}>
                                    {item.siteUrl}
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </div>
                      ) : (
                        <div>No results found!</div>
                      )}
                    </div>
                    {websiteCount >= requestWebsites.PageSize &&
                      websiteList.web.length > 0 && (
                        <div
                          className={`shadow-sm cursor-pointer mt-2 p-1 border border-sky-500 flex items-center justify-center text-sky-500`}
                          onClick={() => loadMore()}
                        >
                          Load More
                        </div>
                      )}
                  </div>
                </ClickAwayListener>
              )}
            </div>
            <div className="relative">
              <div className={` text-sm mb-1 ${colors.primaryText} pl-2`}>
                Keyword
              </div>
              <input
                className="h-8 sm:w-[300px] w-full border relative outline-none pr-[60px] pl-2 text-sm rounded-sm focus:border-[#64CCC5]"
                placeholder={'Please search text'}
                value={state.searchKeyword}
                onChange={(
                  e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
                ) => onSearchHanlder(e)}
                name={'searchKeyword'}
                onKeyDown={handleEnterKeyPress}
                autoComplete="off"
              />
              {state.searchKeyword.length > 0 && (
                <i
                  onClick={() => {
                    setState({ ...state, searchKeyword: '' });
                    setWeblinkResponse(null);
                  }}
                  className="absolute fa-solid fa-xmark sm:left-[280px] right-[10px] top-8 text-gray-500 cursor-pointer"
                ></i>
              )}

              <div className="text-[red] text-sm pl-2 mt-1">
                {formErrors.searchKeyword}
              </div>
            </div>

            <div className="lg:mt-6 mt-2">
              <Button
                label="Search"
                type="button"
                buttonType="primary"
                onClick={() => onSubmit()}
              />
            </div>
          </div>
          <div className="mt-5">
            <WebLinkTable
              state={weblinkResponse}
              // reviewstate={reviewState}
              markYourPreference={markYourPreference}
              page={page}
              limit={limit}
              paginateHandler={paginateHandler}
              totalRowCount={totalRowCount}
            />
          </div>
        </div>
      </div>
      {addKeyword && (
        <div
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.1)' }}
          className="fixed w-full h-screen top-[-20] left-0 right-0 bottom-0 z-[9] flex items-center justify-center overflow-hidden "
        >
          <div className="bg-white w-1/2 shadow-lg relative">
            <div
              className="absolute right-0 p-2 cursor-pointer text-gray-500"
              onClick={() => setAddKeyword(false)}
            >
              <i className="fa-solid fa-xmark"></i>
            </div>
            <div className="p-4">
              <div className={`${colors.primaryText} mb-2`}>
                Entered Keyword is not exist! Add the keyword before marking the
                weblink?
              </div>
              <div className="lg:flex items-center justify-between mb-2">
                <Input
                  name={'searchKeyword'}
                  type={'text'}
                  label={'Keyword'}
                  placeholder={`Enter Keyword`}
                  disabled
                  value={state.searchKeyword}
                />

                <List
                  state={category}
                  clickHandler={onClickCategory}
                  searchHandler={categorySearch}
                  loadMore={loadMoreCategory}
                  pageLimit={categoryRequest.PageSize}
                  totalCount={catTotalCount}
                  error={categoryError}
                />
              </div>
              <div className="flex items-center space-x-4 justify-center">
                <Button
                  label="Submit"
                  type="button"
                  buttonType="primary"
                  onClick={() => onAddKeywords()}
                />
                <Button
                  label="Cancel"
                  type="button"
                  buttonType="danger"
                  onClick={() => setAddKeyword(false)}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ManualSearch;
